import React, { ReactNode, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import authApi from "./auth.api";
import Container from "../components/Layout/Container";
import SessionHandler from "./SessionHandler";
import Loader from "../components/sheriff-wrappers/Loader";
import { AuthContext, AuthContextType } from "./AuthContext";

type AuthContextProviderProps = {
  children: ReactNode;
  headerComponent: ReactNode;
};

export const AuthContextProvider: React.FC<AuthContextProviderProps> = ({
  children,
  headerComponent,
}) => {
  const userInfoQuery = useQuery({
    queryKey: ["userInfo"],
    queryFn: authApi.getUserInfo,
    throwOnError: true,
  });

  const contextValue = useMemo<AuthContextType>(
    () => ({
      userInfo: userInfoQuery.data ? userInfoQuery.data : null,
    }),
    [userInfoQuery.data],
  );

  if (userInfoQuery.isLoading) {
    return (
      <AuthContext.Provider value={contextValue}>
        {headerComponent}
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "2rem",
            }}
          >
            <Loader size={"lg"} />
          </div>
        </Container>
      </AuthContext.Provider>
    );
  }

  return (
    <AuthContext.Provider value={contextValue}>
      <SessionHandler />
      {children}
    </AuthContext.Provider>
  );
};
